import App from "App";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Amplify } from "aws-amplify";
import awsconfig from "aws-exports";
import { AuthProvider } from "context/AuthContext";
import GlobalSubscriptionHandler from "components/GlobalSubscriptionHandler";
import { SoftUIControllerProvider } from "context";
import { NotificationProvider } from "context/NotificationContext";
import "config/env"; // Validate environment variables

// Configure AWS Amplify
// Note: Custom token provider will be set up in App.js after AuthProvider is available
Amplify.configure(awsconfig);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <AuthProvider>
      <GlobalSubscriptionHandler />
      <SoftUIControllerProvider>
        <NotificationProvider>
          <App />
        </NotificationProvider>
      </SoftUIControllerProvider>
    </AuthProvider>
  </BrowserRouter>
);
